import _objectWithoutProperties from "C:\\Users\\danie\\projects\\npm\\react-time-input-polyfill\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "C:\\Users\\danie\\projects\\npm\\react-time-input-polyfill\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "C:\\Users\\danie\\projects\\npm\\react-time-input-polyfill\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "C:\\Users\\danie\\projects\\npm\\react-time-input-polyfill\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\danie\\projects\\npm\\react-time-input-polyfill\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\danie\\projects\\npm\\react-time-input-polyfill\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\danie\\projects\\npm\\react-time-input-polyfill\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\danie\\projects\\npm\\react-time-input-polyfill\\node_modules\\@babel\\runtime/helpers/esm/inherits";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import supportsTime from 'time-input-polyfill/core/helpers/supportsTime';
import loadJS from 'time-input-polyfill/core/helpers/loadJS';
var shiftKey = false;

var leading_zero = function leading_zero(number) {
  if (isNaN(number)) return number;
  var purified = parseInt(number);
  return purified < 10 ? '0' + purified : number;
};

window.addEventListener('keyup', function (e) {
  return shiftKey = e.shiftKey;
});
window.addEventListener('keydown', function (e) {
  return shiftKey = e.shiftKey;
});

var loadPolyfill = function loadPolyfill(polyfillSource, callback) {
  if (window.timePolyfillHelpers) {
    callback();
    return null;
  }

  var cdn = 'https://cdn.jsdelivr.net/npm/react-time-input-polyfill@1/dist/timePolyfillHelpers.js';
  loadJS(polyfillSource || cdn, callback);
};

var accessibility_block_created = false;
var $a11y;
var polyfillClassName = 'react-time-input-polyfill-target';
var customStyles = document.createElement('style');
customStyles.innerHTML = ".".concat(polyfillClassName, "::-ms-clear { display: none; }");
document.getElementsByTagName('head')[0].appendChild(customStyles);

var flash24hrTime = function flash24hrTime(component) {
  return function () {
    if (component.state.usePolyfill) {
      component.setState({
        forcedValue: component.state.value24hr
      });
      setTimeout(function () {
        return component.setState({
          forcedValue: null
        });
      }, 1);
    }
  };
};

var TimeInput =
/*#__PURE__*/
function (_React$Component) {
  _inherits(TimeInput, _React$Component);

  function TimeInput(props) {
    var _this;

    _classCallCheck(this, TimeInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(TimeInput).call(this, props));
    _this.$input = React.createRef();
    _this.focused_via_click = false;
    _this.state = {
      time: {
        hrs: '--',
        min: '--',
        mode: '--'
      },
      value24hr: props.value || '',
      currentSegment: null,
      usePolyfill: !supportsTime,
      forcedValue: null
    };
    return _this;
  }

  _createClass(TimeInput, [{
    key: "onPolyfillLoad",
    value: function onPolyfillLoad(loadedPolyfill) {
      this.polyfill = loadedPolyfill;
      this.setState({
        usePolyfill: true,
        time: this.polyfill.get_values_from_24hr(this.state.value24hr)
      });

      if (!accessibility_block_created) {
        $a11y = this.polyfill.create_a11y_block();
        accessibility_block_created = true;
      }

      this.manual_entry_log = {
        hrs: new this.polyfill.manual_entry_log(),
        min: new this.polyfill.manual_entry_log()
      };
      var $input = this.$input.current;
      $input.polyfill = {
        label: this.polyfill.get_label($input),
        $a11y: $a11y
      };
    }
  }, {
    key: "update_a11y",
    value: function update_a11y(announcementArray) {
      if (!this.state.usePolyfill) return null;
      this.polyfill.update_a11y(this.$input.current, announcementArray);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      setTimeout(function () {
        _this2.flash24hrTime = flash24hrTime(_this2);

        if (_this2.$input.current.form) {
          _this2.$input.current.form.addEventListener('submit', _this2.flash24hrTime);
        }
      }, 0);

      if (this.props.forcePolyfill || !supportsTime) {
        loadPolyfill(this.props.polyfillSource, function () {
          _this2.onPolyfillLoad(window.timePolyfillHelpers);
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.$input.current.form) {
        this.$input.current.form.removeEventListener('submit', this.flash24hrTime);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var hasNewPropsValue = prevProps.value !== this.props.value;
      var hasNewStateValue = prevState.value24hr !== this.state.value24hr;
      if (!hasNewPropsValue && !hasNewStateValue) return null;

      if (hasNewStateValue) {
        this.onTimeChange();
      } else if (hasNewPropsValue) {
        this.set_time(this.props.value);
      }
    }
  }, {
    key: "set_time",
    value: function set_time(time24hr) {
      var _time24hr$split$map = time24hr.split(':').map(function (value) {
        return isNaN(value) ? value : parseInt(value);
      }),
          _time24hr$split$map2 = _slicedToArray(_time24hr$split$map, 2),
          hrs = _time24hr$split$map2[0],
          min = _time24hr$split$map2[1];

      var newTimeValues = this.state.usePolyfill ? {
        hrs: this.polyfill.convert_hours_to_12hr_time(hrs),
        min: min,
        mode: hrs > 12 ? 'PM' : 'AM'
      } : null;
      this.setState({
        time: this.state.usePolyfill ? time24hr ? newTimeValues : {
          hrs: '--',
          min: '--',
          mode: '--'
        } : null,
        value24hr: time24hr
      });
    }
  }, {
    key: "nudge_current_segment",
    value: function nudge_current_segment(direction) {
      var _this3 = this;

      var segment = this.state.currentSegment;
      var current_values = this.state.time;
      var time = {};
      var modifier = direction === 'up' ? 1 : -1;

      if (current_values[segment] === '--') {
        var current_time = function current_time() {
          return new Date();
        };

        time = {
          hrs: function hrs() {
            return _this3.polyfill.convert_hours_to_12hr_time(current_time().getHours());
          },
          min: function min() {
            return current_time().getMinutes();
          },
          mode: function mode() {
            return current_time().getHours() > 11 ? 'PM' : 'AM';
          }
        };
      } else {
        var minutes = {
          up: current_values.min < 59 ? current_values.min + modifier : 0,
          down: current_values.min === 0 ? 59 : current_values.min + modifier
        };
        time = {
          hrs: function hrs() {
            return _this3.polyfill.convert_hours_to_12hr_time(current_values.hrs + modifier);
          },
          min: function min() {
            return minutes[direction];
          },
          mode: function mode() {
            return current_values.mode === 'AM' ? 'PM' : 'AM';
          }
        };
      }

      this.set_segment(segment, time[segment]());
    }
  }, {
    key: "get_12hr_value",
    value: function get_12hr_value(timeObj) {
      var time = timeObj || this.state.time;
      return !time ? '' : [leading_zero(time.hrs), ':', leading_zero(time.min), ' ', time.mode].join('');
    }
  }, {
    key: "set_segment",
    value: function set_segment(segment, value) {
      var time = _objectSpread({}, this.state.time, _defineProperty({}, segment, isNaN(value) ? value : parseInt(value)));

      var value12hr = this.get_12hr_value(time);
      var value24hr = this.polyfill.convert_to_24hr_time(value12hr);
      this.setState({
        time: time,
        value24hr: value24hr
      });
    }
  }, {
    key: "traverse_segments",
    value: function traverse_segments(direction) {
      var _this4 = this;

      var segments = this.polyfill.segments;
      var modifier = direction == 'left' ? -1 : 1;
      var newIndex = segments.indexOf(this.state.currentSegment) + modifier;
      var finalIndex = newIndex <= 0 ? 0 : newIndex >= 2 ? 2 : newIndex;
      var currentSegment = segments[finalIndex];
      this.clear_entry_log();
      this.setState({
        currentSegment: currentSegment
      });
      setTimeout(function () {
        _this4.update_a11y(['select']);
      }, 0);
    }
  }, {
    key: "clear_entry_log",
    value: function clear_entry_log() {
      var currentSegment = this.state.currentSegment;

      if (currentSegment !== 'mode') {
        this.manual_entry_log[currentSegment].clear();
      }
    }
  }, {
    key: "next_segment",
    value: function next_segment() {
      this.traverse_segments('right');
    }
  }, {
    key: "prev_segment",
    value: function prev_segment() {
      this.traverse_segments('left');
    }
  }, {
    key: "clear_current_segment",
    value: function clear_current_segment() {
      this.set_segment(this.state.currentSegment, '--');
    }
  }, {
    key: "onTimeChange",
    value: function onTimeChange() {
      var _this5 = this;

      if (this.props.onChange) {
        this.props.onChange({
          value: this.state.value24hr,
          element: this.$input.current
        });
      }

      setTimeout(function () {
        _this5.update_a11y(['update']);
      }, 0);
    }
  }, {
    key: "handleChange",
    value: function handleChange(e) {
      if (this.state.usePolyfill) return null;
      this.setState({
        value24hr: e.target.value
      });
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(e) {
      this.props.onMouseDown && this.props.onMouseDown(e);
      this.focused_via_click = true;

      if (this.$input.current.matches(':focus')) {
        this.update_a11y(['select']);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      this.props.onClick && this.props.onClick(e);
      if (!this.state.usePolyfill) return null;
      this.polyfill.select_cursor_segment(this.$input.current);
      this.setState({
        currentSegment: this.polyfill.get_current_segment(this.$input.current)
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      this.props.onFocus && this.props.onFocus(e);
      if (!this.state.usePolyfill) return null;
      var segment = shiftKey ? 'mode' : 'hrs';

      if (!this.focused_via_click) {
        this.setState({
          currentSegment: segment
        });
      }

      this.update_a11y(['initial', 'select']);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      this.props.onBlur && this.props.onBlur(e);
      this.focused_via_click = false;
      this.setState({
        currentSegment: null
      });
    }
  }, {
    key: "handleTab",
    value: function handleTab(e) {
      if (e.shiftKey && this.state.currentSegment !== 'hrs') {
        e.preventDefault();
        this.prev_segment();
      } else if (!e.shiftKey && this.state.currentSegment !== 'mode') {
        e.preventDefault();
        this.next_segment();
      }
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      var _this6 = this;

      this.props.onKeyDown && this.props.onKeyDown(e);
      if (!this.state.usePolyfill) return null;
      var key = e.key;
      var actions = {
        ArrowRight: function ArrowRight() {
          return _this6.next_segment();
        },
        ArrowLeft: function ArrowLeft() {
          return _this6.prev_segment();
        },
        ArrowUp: function ArrowUp() {
          return _this6.nudge_current_segment('up');
        },
        ArrowDown: function ArrowDown() {
          return _this6.nudge_current_segment('down');
        },
        Delete: function Delete() {
          return _this6.clear_current_segment();
        },
        Backspace: function Backspace() {
          return _this6.clear_current_segment();
        },
        numberKey: function numberKey() {
          return _this6.enter_number(e.key);
        },
        A_or_P: function A_or_P() {
          return _this6.enter_A_or_P(e.key);
        }
      };
      var isNumberKey = /\d/.test(e.key);
      var is_A_or_P = /[ap]/i.test(e.key);

      if (key === 'Tab') {
        this.handleTab(e);
      } else if (actions[key]) {
        e.preventDefault();
        actions[key]();
      } else if (isNumberKey) {
        actions.numberKey();
      } else if (is_A_or_P) {
        actions.A_or_P();
      } else if (key !== 'Escape') {
        e.preventDefault();
      }
    }
  }, {
    key: "enter_A_or_P",
    value: function enter_A_or_P(key) {
      var isA = /a/i.test(key);
      this.set_segment('mode', isA ? 'AM' : 'PM');
    }
  }, {
    key: "enter_number",
    value: function enter_number(key) {
      var segment = this.state.currentSegment;
      var number = parseInt(key);
      var entry_log = this.manual_entry_log[segment];
      var entry_count = entry_log.items.length;
      var upper_limits = {
        hrs: [1, 2],
        min: [5, 9]
      };
      var limit = upper_limits[segment][entry_count];

      if (entry_count < 2) {
        entry_log.add(number);
      } // Can't be 00 in hours.
      // If the user sets hours to 00 the input automatically changes hours to 12
      // The same behaviour like default input[type="time"].


      if (segment === 'hrs' && entry_log.items.join('') === '00') {
        entry_log.items = [1, 2];
      }

      var full_limit = parseInt(upper_limits[segment].join(''));
      var full_entry = parseInt(entry_log.items.join(''));

      if (full_limit >= full_entry) {
        this.set_segment(segment, full_entry);
      }

      var at_limit = number > limit || entry_log.items.length === 2;

      if (at_limit) {
        this.next_segment();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this7 = this;

      var _this$props = this.props,
          value = _this$props.value,
          forcePolyfill = _this$props.forcePolyfill,
          className = _this$props.className,
          polyfillSource = _this$props.polyfillSource,
          props = _objectWithoutProperties(_this$props, ["value", "forcePolyfill", "className", "polyfillSource"]);

      var _this$state = this.state,
          usePolyfill = _this$state.usePolyfill,
          value24hr = _this$state.value24hr,
          currentSegment = _this$state.currentSegment,
          forcedValue = _this$state.forcedValue;
      var value12hr = usePolyfill ? this.get_12hr_value() : null;

      if (usePolyfill && currentSegment !== null) {
        var highlightSegment = function highlightSegment() {
          return _this7.polyfill.select_segment(_this7.$input.current, currentSegment);
        };

        setTimeout(highlightSegment, 0);
      }

      var polyfillClass = this.state.usePolyfill ? polyfillClassName : '';
      return React.createElement('input', _objectSpread({}, props, {
        onChange: function onChange(e) {
          return _this7.handleChange(e);
        },
        onFocus: function onFocus(e) {
          return _this7.handleFocus(e);
        },
        onBlur: function onBlur(e) {
          return _this7.handleBlur(e);
        },
        onMouseDown: function onMouseDown(e) {
          return _this7.handleMouseDown(e);
        },
        onClick: function onClick(e) {
          return _this7.handleClick(e);
        },
        onKeyDown: function onKeyDown(e) {
          return _this7.handleKeyDown(e);
        },
        ref: this.$input,
        type: usePolyfill ? 'text' : 'time',
        value: usePolyfill ? forcedValue || value12hr : value24hr,
        className: [className || '', polyfillClass].join(' ').trim() || undefined
      }), null);
    }
  }]);

  return TimeInput;
}(React.Component);

export { TimeInput as default };